__turbopack_context__.v({
  "container": "eI_qrq_container",
  "heading": "eI_qrq_heading",
  "size--sm": "eI_qrq_size--sm",
  "subheading": "eI_qrq_subheading",
});
